<!--
 * @Author: 张天昊
 * @Date: 2024-06-24 17:24:49
 * @LastEditTime: 2024-07-08 16:37:23
 * @LastEditors: 张天昊
 * @Description: 
 * @FilePath: /Mobile/src/layout/navbar.vue
-->
<script>
import Vue, { defineComponent } from 'vue';
import YynNavBarInstaller, { YynNavBar } from '@yyn-utils/yyn-nav-bar-legacy';
import '@yyn-utils/yyn-nav-bar-legacy/dist/style.css';
import DefaultLayout from './default.vue';
import NavBarSlotsRight from '@/components/NavBarSlots/right.vue';

Vue.component('YynNavBar', YynNavBar)
// Vue.use(YynNavBarInstaller);

export default defineComponent({
  components: {
    DefaultLayout,
    NavBarSlotsRight
    // YynNavBar
  },
  setup() {}
});
</script>

<template>
  <main class="navbar-layout">
    <YynNavBar>
      <template #right>
        <NavBarSlotsRight />
      </template>
    </YynNavBar>
    <DefaultLayout />
  </main>
</template>

<style>
main.navbar-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main.navbar-layout > *:last-child {
  flex: auto;
}
</style>
